const platformModule = {
  get name() {
    return 'ExponentFileSystem';
  },
  get documentDirectory() {
    return null;
  },
  get cacheDirectory() {
    return null;
  },
  get bundledAssets() {
    return null;
  },
  get bundleDirectory() {
    return null;
  },
  addListener(eventName) {},
  removeListeners(count) {}
};
export default platformModule;